module.exports = __webpack_public_path__ + "static/media/mauritius.6b7a43be.png";